import { render, staticRenderFns } from "./TeamBrainVariation.vue?vue&type=template&id=5b7110fc&scoped=true&"
import script from "./TeamBrainVariation.vue?vue&type=script&lang=js&"
export * from "./TeamBrainVariation.vue?vue&type=script&lang=js&"
import style0 from "./TeamBrainVariation.vue?vue&type=style&index=0&id=5b7110fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7110fc",
  null
  
)

export default component.exports